import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Tooltip } from './index';
const CopyTooltip = ({ onClick, children, tooltip, copiedTooltip, duration = 3000, disabled }) => {
    const [showCopied, setShowCopied] = useState(false);
    const handleClick = useCallbackRef((e) => {
        e.stopPropagation();
        e.preventDefault();
        setShowCopied(true);
        setTimeout(() => {
            setShowCopied(false);
        }, duration);
        onClick();
    });
    return (_jsx(Tooltip, { tooltip: tooltip, trigger: 'hover', placement: 'top', disabled: disabled, children: _jsx(Tooltip, { tooltip: copiedTooltip, visible: showCopied, delayShow: 0, placement: 'top', disabled: disabled, children: React.cloneElement(React.Children.only(children), { onClick: handleClick }) }) }));
};
export default CopyTooltip;
